<template>
   <div class="row bgc-wrapper margin-top-42">
    <div class="col-lg-12 col-md-12 col-sm-12 traveller-heading accordion-toggle">
      <div class="row">
        <div>
          <button
            id = "deletion_of_CPA"
            type="button"
            class="expand-form-button"
            data-toggle="collapse"
            aria-label="Expand Journey Details"
            data-target="#DeletionOfCPA"
          >
            <img alt="Toggle Policy Details" src="@/assets/images/arr-up.png" />
          </button>
        </div>
        <h3>Deletion Of CPA</h3>
      </div>
    </div>
    <div class="collapse show col-lg-12 col-md-12 col-sm-12 bgc-form-box" id="DeletionOfCPA">
        <div class="row">
            <!-- CPA Cover Applicability* starts-->
            <div class=" col-lg-3 col-md-3 col-sm-6" v-if="deletionOfCpaData.cpaApplicability.visibility">
                <div class="row form-group">
                    <float-label label="CPA Cover Applicability*" :fixed="isFloat(deletionOfCpaData.cpaApplicability.value)">
                        <select
                        class="form-control"
                        placeholder="CPA Cover Applicability*"
                        v-model="deletionOfCpaData.cpaApplicability.value"
                        v-evolvews="deletionOfCpaData.cpaApplicability"
                        :class="{ 'bgc-error-field': deletionOfCpaData.cpaApplicability.errorText!=='' }"
                        disabled
                        >
                          <option disabled selected value>CPA Cover Applicability*</option>
                          <option disabled :value='null' v-if='deletionOfCpaData.cpaApplicability.value == null'>CPA Cover Applicability*</option>
                          <option disabled value=''  v-if='deletionOfCpaData.cpaApplicability.value == ""'>CPA Cover Applicability*</option>
                          <option v-for="cpaApplicability in domainValues.cpaApplicabilityResponse.cpaApplicabilityList" :key="cpaApplicability.code" :value="cpaApplicability.code">{{cpaApplicability.name}}</option>
                        </select>
                    </float-label>
                    <span
                        class="error-text"
                        v-if="deletionOfCpaData.cpaApplicability.errorText !== ''"
                        >{{ deletionOfCpaData.cpaApplicability.errorText }}</span>
                </div>
            </div>
            <!-- CPA Cover Applicability* ends-->
            <!-- Exemption Reason* starts-->
            <div class=" col-lg-3 col-md-3 col-sm-6" v-if="deletionOfCpaData.exemptionReason.visibility">
                <div class="row form-group">
                    <float-label label="Exemption Reason*" :fixed="isFloat(deletionOfCpaData.exemptionReason.value)">
                        <select
                          class="form-control"
                          placeholder="Exemption Reason*"
                          :disabled="getSavedQuoteData.riskDetails.customerType=='O'"
                          v-model="deletionOfCpaData.exemptionReason.value"
                          v-evolvews="deletionOfCpaData.exemptionReason"
                          @change="resetData()+checkExemption()"
                          :class="{ 'bgc-error-field': deletionOfCpaData.exemptionReason.errorText!=='' }"
                        >
                          <option disabled :value='null' v-if='deletionOfCpaData.exemptionReason.value == null'>Exemption Reason*</option>
                          <option disabled value=''  v-if='deletionOfCpaData.exemptionReason.value == ""'>Exemption Reason*</option>
                          <option v-for="exemptionReason in state.exemptionReasonsList" :key="exemptionReason.code" :value="exemptionReason.code">{{exemptionReason.name}}</option>
                        </select>
                    </float-label>
                    <span
                        class="error-text"
                        v-if="deletionOfCpaData.exemptionReason.errorText !== ''"
                        >{{ deletionOfCpaData.exemptionReason.errorText }}</span>
                </div>
            </div>
            <!-- Exemption Reason* ends-->
            <!--PA Policy No* starts-->
            <div class="col-lg-3 col-md-3 col-sm-6" v-if="deletionOfCpaData.paPolicyNumber.visibility && deletionOfCpaData.exemptionReason.value == 'AHPACO15L'">
                <div class="row form-group">
                    <float-label label="PA Policy Number*" :fixed="isFloat(deletionOfCpaData.paPolicyNumber.value)"> 
                        <input
                            v-model="deletionOfCpaData.paPolicyNumber.value"
                            v-evolvews="deletionOfCpaData.paPolicyNumber"
                            v-on:keydown="onlyNumber"
                            type="text"
                            maxlength="30"
                            :class="{'bgc-error-field':deletionOfCpaData.paPolicyNumber.errorText !== ''}"
                            class="form-control"
                            placeholder="PA Policy Number*"
                        />
                    </float-label>
                    <span class="error-text" v-if="deletionOfCpaData.paPolicyNumber.errorText !== ''">
                        {{deletionOfCpaData.paPolicyNumber.errorText}}</span>
                </div>
            </div>
            <!--PA Policy No* ends-->
            <!--PA Insurer Name starts-->
            <div class="col-lg-3 col-md-3 col-sm-6" v-if="deletionOfCpaData.paInsurerName.visibility && deletionOfCpaData.exemptionReason.value == 'AHPACO15L'">
                <div class="row form-group">
                    <float-label label="PA Insurer Name*" :fixed="isFloat(deletionOfCpaData.paInsurerName.value)"> 
                        <select
                          class="form-control"
                          placeholder="PA Insurer Name*"
                          v-model="deletionOfCpaData.paInsurerName.value"
                          v-evolvews="deletionOfCpaData.paInsurerName"
                        >
                          <!-- <option disabled selected value>Insurer Name</option> -->
                          <option disabled :value='null' v-if='deletionOfCpaData.paInsurerName.value == null'>PA Insurer Name*</option>
                          <option disabled value=''  v-if='deletionOfCpaData.paInsurerName.value == ""'>PA Insurer Name*</option>
                          <option v-for="insurer in domainValues.initPreviousPolicyDetails.insuranceCompanies" :key="insurer.code" :value="insurer.code">{{insurer.name}}</option>
                        </select>
                    </float-label>
                    <span class="error-text" v-if="deletionOfCpaData.paInsurerName.errorText !== ''">
                        {{deletionOfCpaData.paInsurerName.errorText}}</span>
                </div>
            </div>
            <!--PA Insurer Name ends-->
            <!-- PA Policy Inception Date* starts-->
            <div class="col-lg-3 col-md-3 col-sm-6" v-if="deletionOfCpaData.paPolicyInceptionDate.visibility && deletionOfCpaData.exemptionReason.value == 'AHPACO15L'">
                <div class="row form-group">
                    <float-label label="PA Policy Inception Date*" :fixed="isFloat(deletionOfCpaData.paPolicyInceptionDate.value)">
                        <datepicker
                        v-model="deletionOfCpaData.paPolicyInceptionDate.value"
                        v-evolvews="deletionOfCpaData.paPolicyInceptionDate"
                        :typeable="true"
                        format="dd/MM/yyyy"
                        placeholder="PA Policy Inception Date*"
                        :disabledDates="disableInceptionDate" 
                        :input-class="isInputError(deletionOfCpaData.paPolicyInceptionDate.errorText)"
                        @selected="checkError(deletionOfCpaData.paPolicyInceptionDate,false)"
                        @input="checkError(deletionOfCpaData.paPolicyInceptionDate,false)"
                        ></datepicker>
                    </float-label>
                    <span
                        class="error-text"
                        v-if="deletionOfCpaData.paPolicyInceptionDate.errorText !== ''"
                    >{{deletionOfCpaData.paPolicyInceptionDate.errorText}}</span>
                </div>
            </div>
            <!--PA Policy Inception Date ends-->
            <!-- PA Policy Expiry Date* starts-->
            <div class="col-lg-3 col-md-3 col-sm-6" v-if="deletionOfCpaData.paPolicyExpiryDate.visibility && deletionOfCpaData.exemptionReason.value == 'AHPACO15L'">
                <div class="row form-group">
                    <float-label label="PA Policy Expiry Date*" :fixed="isFloat(deletionOfCpaData.paPolicyExpiryDate.value)">
                        <datepicker
                        v-model="deletionOfCpaData.paPolicyExpiryDate.value"
                        v-evolvews="deletionOfCpaData.paPolicyExpiryDate"
                        :typeable="true"
                        format="dd/MM/yyyy"
                        placeholder="PA Policy Expiry Date*"
                        :disabledDates="disableExpiryDate" 
                        :input-class="isInputError(deletionOfCpaData.paPolicyExpiryDate.errorText)"
                        @selected="checkError(deletionOfCpaData.paPolicyExpiryDate,false)"
                        @input="checkError(deletionOfCpaData.paPolicyExpiryDate,false)"
                        ></datepicker>
                    </float-label>
                    <span
                        class="error-text"
                        v-if="deletionOfCpaData.paPolicyExpiryDate.errorText !== ''"
                    >{{deletionOfCpaData.paPolicyExpiryDate.errorText}}</span>
                </div>
            </div>
            <!--PA Policy Expiry Date ends-->
        </div>
    </div>
    </div>
</template>

<script>
import FloatLabel from "@/../shared_component/FloatLabel.vue";
import Datepicker from "vuejs-datepicker";
import functions from "@/../../masters/functions.js";
import moment from "moment";
// import base from "@/../../masters/base.js";
// import Breadcrumb from "@/../../shared_component/Breadcrumb.vue";
// import vSelect from "vue-select";
import { reactive, onUpdated, onMounted, computed} from "@vue/composition-api";
export default {
  name: "DeletionOfCPA",
  props: ["deletionOfCpaData", "domainValues",'cpaDurationList','getSavedQuoteData','isCpaMandatory'],
  components: {
    FloatLabel,
    Datepicker
  },
  setup(props, context) {
    let state = reactive({
      exemptionReasonsList: []
    });
    //onMounted
    onMounted(()=>{
      state.exemptionReasonsList = JSON.parse(JSON.stringify(props.domainValues.initMotorDomainLists.exemptionReasons));
      if(props.getSavedQuoteData.riskDetails.customerType == 'O'){
        props.deletionOfCpaData.exemptionReason.value = 'I'
      }
      else{
        state.exemptionReasonsList = props.domainValues.initMotorDomainLists.exemptionReasons.filter(exemptionReason=>{
          return (exemptionReason.code != 'I'); //  && exemptionReason.code != 'O'
        });
      }
      checkExemption();
      if(props.isCpaMandatory){
        state.exemptionReasonsList =  state.exemptionReasonsList.filter(exemptionReason=>{
          return exemptionReason.code != 'O';
        });
      }
    });
    const checkError = functions.checkError;
    const isInputError = functions.isInputError;
    const isFloat = functions.isFloat;
    const onlyNumber= functions.onlyNumber;
    const onlyCharSpace= functions.onlyCharSpace;
    const ObjDateFormated = functions.ObjDateFormated;
    function resetData(){
      props.deletionOfCpaData.paPolicyNumber.errorText = '';
      props.deletionOfCpaData.paInsurerName.errorText = '';
      props.deletionOfCpaData.paPolicyInceptionDate.errorText = '';
      props.deletionOfCpaData.paPolicyExpiryDate.errorText = '';
      props.deletionOfCpaData.paPolicyNumber.value = props.deletionOfCpaData.paPolicyNumber.oldValue;
      props.deletionOfCpaData.paInsurerName.value = props.deletionOfCpaData.paInsurerName.oldValue;
      props.deletionOfCpaData.paPolicyInceptionDate.value = props.deletionOfCpaData.paPolicyInceptionDate.oldValue;
      props.deletionOfCpaData.paPolicyExpiryDate.value = props.deletionOfCpaData.paPolicyExpiryDate.oldValue;
    }
    function checkExemption(){
      if(props.deletionOfCpaData.cpaApplicability.value == 'E' && props.deletionOfCpaData.exemptionReason.value == 'AHPACO15L'){
        context.root.$set(props.deletionOfCpaData.paPolicyNumber,'stepsMandatory', true);
        context.root.$set(props.deletionOfCpaData.paInsurerName,'stepsMandatory', true);
        context.root.$set(props.deletionOfCpaData.paPolicyInceptionDate,'stepsMandatory', true);
        context.root.$set(props.deletionOfCpaData.paPolicyExpiryDate,'stepsMandatory', true);
        delete props.deletionOfCpaData.paPolicyNumber.skip;
        delete props.deletionOfCpaData.paInsurerName.skip;
        delete props.deletionOfCpaData.paPolicyInceptionDate.skip;
        delete props.deletionOfCpaData.paPolicyExpiryDate.skip;
      }
      else{
        context.root.$set(props.deletionOfCpaData.paPolicyNumber,'skip', true);
        context.root.$set(props.deletionOfCpaData.paInsurerName,'skip', true);
        context.root.$set(props.deletionOfCpaData.paPolicyInceptionDate,'skip', true);
        context.root.$set(props.deletionOfCpaData.paPolicyExpiryDate,'skip', true);
        delete props.deletionOfCpaData.paPolicyNumber.stepsMandatory;
        delete props.deletionOfCpaData.paInsurerName.stepsMandatory;
        delete props.deletionOfCpaData.paPolicyInceptionDate.stepsMandatory;
        delete props.deletionOfCpaData.paPolicyExpiryDate.stepsMandatory;
      }
    }
    onUpdated(()=>{
      // let progressStep = 0;
      // Object.values(props.deletionOfCpaData).forEach(obj => {
      //   if(obj.stepsMandatory){
      //     if(obj.value && !obj.errorText){
      //       progressStep++;
      //     }
      //   }
      // })
      context.parent.calculateSteps();
      if(props.getSavedQuoteData.riskDetails.cpaApplicability == 'C')
        context.parent.enableCalculatePremiumBtn('deletionOfCpa');
    })
    const disableInceptionDate= computed(()=>{
        return {
          from: moment(ObjDateFormated(props.getSavedQuoteData.motorPolicyBasicDetails.policyInceptionDate)).add(1,'d').startOf('day').toDate()
        }
    })
    const disableExpiryDate= computed(()=>{
        return {
          to: moment(ObjDateFormated(props.getSavedQuoteData.motorPolicyBasicDetails.policyInceptionDate)).add(1,'d').startOf('day').toDate()
        }
    })
    return {
      state,
      isFloat,
      checkError,
      onlyNumber,
      onlyCharSpace,
      isInputError,
      disableInceptionDate,
      disableExpiryDate,
      resetData,
      checkExemption
    };
  },
   directives: {
    evolvews: functions.evolvews
  }
};
</script>
